import React, { useEffect } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { GOOGLE_CLIENT_ID } from './utils/config';
import { useAuth } from './components/AuthContext';
import { KanbanProvider } from './components/KanbanContext';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Profile from './components/Profile';
import './App.css';

function AppContent() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  // Establecer el título de la página
  useEffect(() => {
    document.title = "XinerLink Flows";
  }, []);
  
  // Asegurarse de que después del inicio de sesión el usuario vaya al Home
  useEffect(() => {
    // Solo ejecutar esta lógica cuando cambie el usuario (inicio de sesión)
    if (currentUser) {
      const justLoggedIn = sessionStorage.getItem('justLoggedIn');
      if (justLoggedIn === 'true') {
        // Asegurarse de que estamos en la ruta de inicio
        navigate('/', { replace: true });
        // Eliminar el indicador después de haber hecho la redirección
        sessionStorage.removeItem('justLoggedIn');
      }
    }
  }, [currentUser, navigate]);

  return (
    <KanbanProvider>
      <div className="App">
        {currentUser && <Navbar />}
        <main className={`App-main ${!currentUser ? 'no-navbar' : ''}`}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route 
              path="/profile" 
              element={currentUser ? <Profile /> : <Navigate to="/" />} 
            />
          </Routes>
        </main>
      </div>
    </KanbanProvider>
  );
}

function App() {
  // Establecer el título de la página para asegurar que funcione en toda la aplicación
  useEffect(() => {
    document.title = "XinerLink Flows";
  }, []);

  if (!GOOGLE_CLIENT_ID) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h2 className="login-title">Configuración incompleta</h2>
          <p className="login-error">
            Falta la variable <code>REACT_APP_GOOGLE_CLIENT_ID</code> en el entorno del frontend.
          </p>
          <p style={{ fontSize: 14, color: '#555', textAlign: 'center' }}>
            Si corres en local, verifica el archivo <code>.env</code> y reinicia con <code>npm start</code>.
            Si es un deploy, agrega la variable en el hosting y vuelve a construir la app.
          </p>
        </div>
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <AppContent />
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
